import { useLocation } from 'react-router-dom';
import { Search } from 'lucide-react';
import { findNavEntry } from '@/lib/navigation';

// The palette listens for this event (plus ⌘K) — the search field in the bar
// is a real control, not decoration.
export function openCommandPalette() {
  window.dispatchEvent(new CustomEvent('gf:open-palette'));
}

export function TopBar({ mobileNavOpen, onToggleMobileNav }: { mobileNavOpen: boolean; onToggleMobileNav: () => void }) {
  const { pathname } = useLocation();
  const entry = findNavEntry(pathname);

  return (
    <header className="glass z-10 flex h-12 shrink-0 items-center gap-2 border-b border-black/[0.06] px-3 sm:gap-3 sm:px-5">
      <button type="button" aria-label={mobileNavOpen ? 'Close navigation' : 'Open navigation'} aria-expanded={mobileNavOpen} aria-controls="mobile-navigation" onClick={onToggleMobileNav} className="flex h-7 w-7 shrink-0 items-center justify-center rounded-[7px] text-subtle hover:bg-black/[0.05] hover:text-text sm:hidden"><span aria-hidden>{mobileNavOpen ? '×' : '☰'}</span></button>
      <div className="flex min-w-0 items-baseline gap-2">
        {entry?.group && (
          <span className="hidden text-[11px] font-medium text-subtle sm:block">{entry.group} /</span>
        )}
        <h2 className="truncate text-[13px] font-semibold tracking-tight">{entry?.label ?? ''}</h2>
      </div>

      <button
        onClick={openCommandPalette}
        aria-label="Open command palette"
        className="ml-auto flex h-7 w-9 shrink-0 items-center justify-center gap-2 rounded-[8px] border border-black/[0.07] bg-bg/70 px-0 text-[11.5px] text-subtle transition-colors hover:border-black/[0.12] hover:bg-bg sm:w-[260px] sm:justify-start sm:px-2.5"
      >
        <Search className="h-3.5 w-3.5" aria-hidden />
        <span className="hidden flex-1 text-left sm:block">Search…</span>
        <kbd className="hidden rounded-[4px] bg-white px-1.5 py-0.5 font-mono text-[10px] text-muted shadow-[0_0.5px_1px_rgba(0,0,0,0.1)] sm:block">⌘K</kbd>
      </button>
    </header>
  );
}
